import React from "react"
import useSSR from "use-ssr"

export const useAnchorLinkEventListener = (handler) => {
	const { isServer } = useSSR()

	React.useEffect(() => {
		if (isServer) return

		window.addEventListener("popstate", handler)
		return () => window.removeEventListener("popstate", handler)
	}, [isServer])
}

export const useHandleHashChange = (
	setter: React.Dispatch<React.SetStateAction<string>>
) => {
	const handleHashChange = React.useCallback((e) => {
		e.preventDefault()

		if (!window) return

		const { hash } = window.location
		if (hash?.length > 0) {
			const id = hash.substring(1, hash.length)
			setter(id)
		}
	}, [])

	useAnchorLinkEventListener(handleHashChange)
}
